/**
 * roster.js - Roster Configuration Constants
 * Phase 3B - Named exports only
 */

export const SLOT_POSITIONS = {
  QB: ['QB'],
  RB1: ['RB'],
  RB2: ['RB'],
  WR1: ['WR'],
  WR2: ['WR'],
  TE: ['TE'],
  FLEX: ['RB', 'WR', 'TE'],
};

export const INITIAL_ROSTER = [
  { slot: 1, label: 'QB', player: null, prop: null, side: null, units: 0 },
  { slot: 2, label: 'RB1', player: null, prop: null, side: null, units: 0 },
  { slot: 3, label: 'RB2', player: null, prop: null, side: null, units: 0 },
  { slot: 4, label: 'WR1', player: null, prop: null, side: null, units: 0 },
  { slot: 5, label: 'WR2', player: null, prop: null, side: null, units: 0 },
  { slot: 6, label: 'TE', player: null, prop: null, side: null, units: 0 },
  { slot: 7, label: 'FLEX', player: null, prop: null, side: null, units: 0 },
];

export const DEFAULT_POOL_UNITS = 100;
export const DEFAULT_SLOT_COUNT = 7;
